import {Action} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ZonaExclusion} from './zonas-exclusion.state';

export enum ZonasExclusionActionTypes {
  LOAD_REQUEST = '[ZONASEXCLUSION] Load Request',
  LOAD_FAILURE = '[ZONASEXCLUSION] Load Failure',
  LOAD_SUCCESS = '[ZONASEXCLUSION] Load Success',
  ADD_REQUEST = '[ZONASEXCLUSION] Add Request',
  ADD_FAILURE = '[ZONASEXCLUSION] Add Failure',
  ADD_SUCCESS = '[ZONASEXCLUSION] Add Success',
  CHANGE_REQUEST = '[ZONASEXCLUSION] Change Request',
  CHANGE_FAILURE = '[ZONASEXCLUSION] Change Failure',
  CHANGE_SUCCESS = '[ZONASEXCLUSION] Change Success',
  DELETE_REQUEST = '[ZONASEXCLUSION] Delete Request',
  DELETE_FAILURE = '[ZONASEXCLUSION] Delete Failure',
  DELETE_SUCCESS = '[ZONASEXCLUSION] Delete Success'
}

// load

export class ZonasExclusionLoadRequestAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.LOAD_REQUEST;
}

export class ZonasExclusionLoadFailureAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ZonasExclusionLoadSuccessAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.LOAD_SUCCESS;

  constructor(public payload: { items: ZonaExclusion[] }) {
  }
}

// add
export class ZonasExclusionAddRequestAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.ADD_REQUEST;

  constructor(public payload: { item: ZonaExclusion }) {
  }
}

export class ZonasExclusionAddFailureAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.ADD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ZonasExclusionAddSuccessAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.ADD_SUCCESS;

  constructor(public payload: { item: ZonaExclusion }) {
  }
}

// change

export class ZonasExclusionChangeRequestAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.CHANGE_REQUEST;

  constructor(public payload: { item: ZonaExclusion }) {
  }
}

export class ZonasExclusionChangeFailureAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.CHANGE_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ZonasExclusionChangeSuccessAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.CHANGE_SUCCESS;

  constructor(
    public payload: { item: Update<ZonaExclusion> }
  ) {
  }
}

// delete

export class ZonasExclusionDeleteRequestAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.DELETE_REQUEST;

  constructor(public payload: { item: ZonaExclusion }) {
  }
}

export class ZonasExclusionDeleteFailureAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.DELETE_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ZonasExclusionDeleteSuccessAction implements Action {
  readonly type =
    ZonasExclusionActionTypes.DELETE_SUCCESS;

  constructor(public payload: { item: ZonaExclusion }) {
  }
}

// actions

export type ZonasExclusionActions =
  | ZonasExclusionLoadRequestAction
  | ZonasExclusionLoadFailureAction
  | ZonasExclusionLoadSuccessAction
  | ZonasExclusionAddRequestAction
  | ZonasExclusionAddFailureAction
  | ZonasExclusionAddSuccessAction
  | ZonasExclusionChangeRequestAction
  | ZonasExclusionChangeFailureAction
  | ZonasExclusionChangeSuccessAction
  | ZonasExclusionDeleteRequestAction
  | ZonasExclusionDeleteFailureAction
  | ZonasExclusionDeleteSuccessAction;
